import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText, HeaderText } from '../../ui';
import { CardCarousel, CarouselCard } from '../../ui/CardCarousel';
import SignupCountdownTextContainer from '../today/SignupCountdown/SignupCountdownTextContainer';

import './OnboardingCarousel.module.scss';

function OnboardingCarousel({ provider, firstName, cards }) {
  const completeSteps = cards.filter(({ complete }) => complete).length;
  const totalSteps = cards.length;

  return (
    <Box color={colors.superLight} testID="onboarding-carousel">
      <Box alignItems="center">
        <Box
          maxWidth={911}
          style={{ width: '100%' }}
          justifyContent="flex-start"
        >
          <HeaderText
            level={3}
            styleName="header"
            textAlign="left"
            testID="onboarding-carousel-header"
          >
            {`${firstName}, list your business and get exposure to new clients in a few steps.`}
          </HeaderText>
          <BodyText styleName="cards-complete">
            <BodyText styleName="n-of-m" testID="onboarding-steps-complete">
              {`${completeSteps} of ${totalSteps}`}
            </BodyText>
            &nbsp;Complete
          </BodyText>
        </Box>
      </Box>
      <View styleName="children-container">
        <CardCarousel>
          {cards.map(card => (
            <CarouselCard
              key={card.key}
              icon={card.complete ? card.completeIcon : card.incompleteIcon}
              title={card.title}
              body={card.body}
              cta={card.cta}
              onDismiss={card.onDismiss}
              backgroundColor={card.backgroundColor}
              ctaProps={{
                onClick: card.onClick,
                active: card.complete,
              }}
              testID={`${typeof card.title === 'string' ? card.title : card.key}-test`}
            />
          ))}
        </CardCarousel>
        <Box color={colors.superLight} alignItems="center">
          <Box maxWidth={911} style={{ width: '100%' }}>
            <SignupCountdownTextContainer provider={provider} />
          </Box>
        </Box>
      </View>
    </Box>
  );
}

OnboardingCarousel.propTypes = {
  cards: PropTypes.array.isRequired,
  provider: PropTypes.object.isRequired,
  firstName: PropTypes.string.isRequired,
};

export default OnboardingCarousel;
